
import {common_utils} from "../common/common_utils";
import {slots_tool} from "./slots_tool";
import {Game_5016} from "./game_5016";

function game_5015()
{

}

game_5015.rows = 3;
game_5015.colum= 5;

game_5015.parseResult = function(obj, data)
{
      let detail = data.detail;
      obj.hasextra = false
      obj.hasfree = true
      obj.hasbonuswin = false;
      common_utils.readDataValue(obj,data);

      obj.mapList = []
      obj.wins = []
      if(data.isFree != 0)
      {
         obj.isfree = obj.$t('lang.str_t');
      }
      else
      {
        obj.isfree = obj.$t('lang.str_f');
      }
      let map_data = detail.mapData;
      let mapJson =  JSON.parse(map_data);
      let map = mapJson["Map"]
      if(map)
      {
          let mapTmp = slots_tool.setMap(map,game_5015.rows,game_5015.colum);
          obj.mapList.push(mapTmp);
          let winList = mapJson["Ls"];
          let winTmp = game_5015.setWin(winList,detail.bet,game_5015.colum);
          obj.wins.push(winTmp);
      }
      console.log(obj.mapList)

      let wins = obj.wins;
      if(wins&&wins.length>0)
      {
        for(let i = 0;i<wins.length;i++)
        {
          let mapTmp = obj.mapList[i];
          let winInfos = wins[i];
          if(winInfos.length>0)
          {
            for(let j = 0;j<winInfos.length;j++)
            {
              let winInfo = winInfos[j];
              let WinNum =  winInfo.win_index.length;
              let winIndex= winInfo.win_index;
              if(winIndex)
              {
                for(let m = 0;m<WinNum;m++)
                {
                    let index = winIndex[m];
                    let item = mapTmp[index];
                    item.isWin = true;
                    mapTmp[index] = item;
                }

              }
            }
          }
          obj.mapList[i] = mapTmp;
        }
      }
}



game_5015.setWin = function(winList, bet_chip, maxColum)
{
    let win_list = [];
    let len = winList.length;
    for(let i = 0;i<len;i++)
    {
        let value = winList[i];
        let winItem =  game_5015.winItemValue(value,maxColum);
        win_list.push(winItem);
    }
    return win_list;
}

game_5015.winItemValue = function(value, maxColum)
{
    let winInfo = {};
    if(value)
    {
        winInfo.win_index = game_5015.parseWinIndex(value["l"],maxColum);
        winInfo.win_key = value["S"];
    }
  return winInfo;
}

game_5015.parseWinIndex =function(indexList, maxColum)
{
    let newList = [];
    if(indexList == null||indexList.length == 0)
    {
      return newList;
    }
    let len = indexList.length;
    for(let colum = 0;colum<len;colum++)
    {
        let index = indexList[colum];
        newList.push(index*maxColum+colum);
    }
    return newList;
}

game_5015.setMap = function(map, rows, colum)
{
    let mapTmp = [];
    for (var j = 0; j < rows; j++)
    {
      for (var i = 0; i < colum; i++)
      {
          let value = map[i][j];
          let obj = game_5015.splitItemValue(value);
          mapTmp.push(obj)
      }
    }
    return mapTmp;
}

game_5015.splitItemValue = function(data)
{
    let item = {};
    let one_map = data.split("_");
    if(one_map&&one_map.length>1)
    {
        for(let i = 0;i < one_map.length;i++)
        {
          let value = one_map[i];
          if(i === 0)
          {
              item.itemValue = value;
          }
          else if(i === 1)
          {
              item.itemNum = parseInt(value);
              item.itemNumStr = value;
          }
          else if(i === 2)
          {
             item.multiple = parseInt(value);
          }
        }
    }
    else
    {
        item.itemValue = data;
        item.itemNum = 1;
        item.multiple = 1;
    }
    item.isWin =  false;
    return item;
}

export {
  game_5015
};




// WEBPACK FOOTER //
// ./src/components/slots/game_5015.js